const endpoints = {
	createCostCategory: '/cost/createCostCategory',
	createCostSubcategory: '/cost/createCostSubcategory',
	createCostItem: '/cost/createCostItem',
	getCostCategories: '/cost/getCostCategories',
	getCostCategory: '/cost/getCostCategory',
	saveAllCostCategory: '/cost/saveAllCostCategory',
	deleteCostCategory: '/cost/deleteCostCategory',
	deleteCostSubcategory: '/cost/deleteCostSubcategory',
	deleteCostItem: '/cost/deleteCostItem',
	//Nuevo Sistema
	updateProjectCostInfo: '/cost/updateProjectCostInfo',
	getProjectCostDetail: '/cost/getProjectCostDetail',
	saveSupervisionItem: '/cost/saveSupervisionItem',
	saveProjectCostDetail: '/cost/saveProjectCostDetail',
	updateSupervisionPaymentObservation: '/cost/updateSupervisionPaymentObservation',
	sendTableCostTotalsToClient: '/cost/sendTableCostTotalsToClient',
	sendSupervisionTableToClient: '/cost/sendSupervisionTableToClient',
	generateTableCostTotalsPdf: '/cost/generateTableCostTotalsPdf',
	generateSupervisionTablePdf: '/cost/generateSupervisionTablePdf',
	setProjectSelectionToSubcontractor: '/cost/setProjectSelectionToSubcontractor',
	getProjectSelectionToSubcontractor: '/cost/getProjectSelectionToSubcontractor',

	//Config
	getCompanyBaseProjectCostCategories: '/cost/config/getCompanyBaseProjectCostCategories',
	saveAllCostCategoriesCompanyConfig: '/cost/config/saveAllCostCategoriesCompanyConfig',
	getCostBaseProjects: '/cost/config/getCostBaseProjects',
	createCostBaseProject: '/cost/config/createCostBaseProject',
	updateCostBaseProject: '/cost/config/updateCostBaseProject',
	deleteCostBaseProject: '/cost/config/deleteCostBaseProject',
	
	setCompanyCostCategory: '/cost/config/setCompanyCostCategory',
	deleteCompanyCostCategory: '/cost/config/deleteCompanyCostCategory',
	getCompanyCostCategories: '/cost/config/getCompanyCostCategories',
	getCompanyCostCategory: '/cost/config/getCompanyCostCategory',

	createCostSpecialtyCompany: '/cost/config/createCostSpecialty',
	getCostSpecialtiesCompany: '/cost/config/getCostSpecialties',
	updateCostSpecialty: '/cost/config/updateCostSpecialty',
	deleteCostSpecialtyCompany: '/cost/config/deleteCostSpecialty',
	createCostSubCategoryCompany: '/cost/config/createCostSubcategory',
	updateCostSubCategory: '/cost/config/updateCostSubcategory',
	deleteCostSubCategoryCompany: '/cost/config/deleteCostSubcategory',
	createCostItemCompany: '/cost/config/createCostItem',
	getCompanyCostItems: '/cost/config/getCompanyCostItems',
	updateCostItem: '/cost/config/updateCostItem',
	deleteCostItemCompany: '/cost/config/deleteCostItem',
	deleteCostCenter: '/cost/config/deleteCostCenter',
	createCostCenter: '/cost/config/createCostCenter',
	updateCostCenter: '/cost/config/updateCostCenter',
	getCompanyCostTemplates: '/cost/config/getCompanyCostTemplates',
	createCostTemplate: '/cost/config/createCostTemplate',
	deleteCostTemplate: '/cost/config/deleteCostTemplate',

	getCompanyMaterials: '/cost/config/getCompanyMaterials',
	createCompanyMaterial: '/cost/config/createCompanyMaterial',
	updateCompanyMaterial: '/cost/config/updateCompanyMaterial',
	deleteCompanyMaterial: '/cost/config/deleteCompanyMaterial',

	getCompanySupervisionPercents: '/cost/config/getCompanySupervisionPercents',
	createCompanySupervisionPercent: '/cost/config/createCompanySupervisionPercent',
	updateCompanySupervisionPercent: '/cost/config/updateCompanySupervisionPercent',
	deleteCompanySupervisionPercent: '/cost/config/deleteCompanySupervisionPercent',
}
export {endpoints}